import React from 'react';
import { FormInputText } from '../../../common/formInputsV2/FormInputText';

function StepContatti({
  register, errors, isValid, watch, setValue,
}) {
  const hasContactPerson = watch('has_contact_person');

  /* Cleared on the way out, not just hidden: the three fields keep whatever was typed before the
     broker changed their mind, and buildCauzioniPayload reads them straight off the form — so a
     hidden field would still be filed as the request's referente. */
  const toggleContactPerson = (checked) => {
    setValue('has_contact_person', checked);
    if (!checked) {
      ['contact_name', 'contact_phone', 'contact_email'].forEach(
        (field) => setValue(field, '', { shouldValidate: true }),
      );
    }
  };

  return (
    <div data-testid="cauzioni-step-contatti">
      <div className="cauzioni-info-card">
        <div className="cauzioni-card-body">
          <h2 className="cauzioni-card-title mb-3">Contatti</h2>
          <FormInputText
            label="Email *"
            registration={register('email')}
            error={errors.email?.message}
            valid={isValid('email')}
          />
          <FormInputText
            label="PEC *"
            registration={register('pec')}
            error={errors.pec?.message}
            valid={isValid('pec')}
          />
          <FormInputText
            label="Telefono *"
            registration={register('phone')}
            error={errors.phone?.message}
            valid={isValid('phone')}
          />
        </div>
      </div>

      <div className="cauzioni-info-card">
        <div className="cauzioni-card-body">
          <div className="cauzioni-section-head">
            <h2 className="cauzioni-card-title mb-0">Referente Aziendale</h2>
            <span className="cauzioni-optional-badge">Facoltativo</span>
          </div>
          <p className="cauzioni-section-hint">
            Indica un referente solo se le comunicazioni sulla pratica devono essere gestite da
            una persona diversa dal contraente.
          </p>

          <label className="cauzioni-optional-toggle" htmlFor="has_contact_person">
            <input
              type="checkbox"
              id="has_contact_person"
              className="checkbox"
              checked={!!hasContactPerson}
              onChange={(e) => toggleContactPerson(e.target.checked)}
              data-testid="cauzioni-contact-person-toggle"
            />
            <span>Voglio indicare un referente aziendale</span>
          </label>

          {hasContactPerson && (
            <div className="cauzioni-optional-fields">
              <FormInputText
                label="Nome referente"
                registration={register('contact_name')}
                error={errors.contact_name?.message}
                valid={isValid('contact_name')}
              />
              <FormInputText
                label="Telefono referente"
                registration={register('contact_phone')}
                error={errors.contact_phone?.message}
                valid={isValid('contact_phone')}
              />
              <FormInputText
                label="Email referente"
                registration={register('contact_email')}
                error={errors.contact_email?.message}
                valid={isValid('contact_email')}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default StepContatti;
